import { Link } from "react-router-dom";
import { LEGAL } from "@/config/legal";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-[#0A1128] flex items-center justify-center">
              <span className="text-[#D4AF37] font-serif text-lg leading-none">G</span>
            </div>
            <div>
              <div className="font-serif text-xl tracking-tight text-[#0A1128]">Guest Smell<sup className="text-[10px] text-slate-500">™</sup></div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-semibold">See It · Smell It · Book It.™</div>
            </div>
          </div>
          <p className="mt-4 text-slate-500 text-sm max-w-md">
            The freshness verification standard for hospitality. Certifying the air, humidity, and cleanliness of the world&apos;s best stays.
          </p>
          <p className="mt-4 text-xs text-slate-400" data-testid="footer-founder">
            Founded by <span className="text-[#0A1128] font-medium">{LEGAL.founderName}</span>.
          </p>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500 font-semibold">Product</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/browse" className="hover:text-emerald-700">Certified Stays</Link></li>
            <li><Link to="/wellness" className="hover:text-emerald-700" data-testid="footer-wellness">Wellness-Ready Stays</Link></li>
            <li><Link to="/pricing" className="hover:text-emerald-700">Pricing</Link></li>
            <li><Link to="/about" className="hover:text-emerald-700">About</Link></li>
            <li><Link to="/contact" className="hover:text-emerald-700">Contact</Link></li>
            <li><Link to="/vision" className="hover:text-emerald-700">Investor Vision</Link></li>
            <li><Link to="/vision#device" className="hover:text-emerald-700">Guest Smell Verify™</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500 font-semibold">For You</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/register" className="hover:text-emerald-700">Become a Host</Link></li>
            <li><Link to="/register" className="hover:text-emerald-700">Guest Sign-up</Link></li>
            <li><Link to="/login" className="hover:text-emerald-700">Sign in</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500 font-semibold">Legal</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li><Link to="/terms" className="hover:text-emerald-700" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-emerald-700" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-emerald-700" data-testid="footer-refund">Refund Policy</Link></li>
            <li><a href={`mailto:${LEGAL.legalEmail}`} className="hover:text-emerald-700">{LEGAL.legalEmail}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} {LEGAL.brandMark} · See It. Smell It. Book It.™
      </div>
    </footer>
  );
}
